import React, { useContext, useEffect, useState } from "react";
import PedidosYaStyle from "../../../../assets/css/components/admin/plugins/PedidosYaStyle";
import { Redirect } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import verifyAccessRole from "../../../../assets/js/verifyAccessRole";
import Routes from "../../../../Routes";
import { GlobalContext } from "../../../../contexts/GlobalContext";
import OdooStyle from "../../../../assets/css/components/admin/plugins/OdooStyle.css";
import View from "./view";
import { FaPlus } from "react-icons/fa";
import { Button } from "../../../../assets/css/components/admin/marketplace-to-marketplace/filters/FiltersStyles";
import VtexCredentials from "./vtexCredentials";
import { accVtex, downloadCategoriesVtex, getWarehouses, syncProductsVtex } from "../../../../hooks/api/vtex";

export default function VtexConfig() {
  const [redirect, setRedirect] = useState(null);
  const globalContext = useContext(GlobalContext);
  const [selectedMarketplace, setSelectedMarketplace] = useState(null);
  const [loading, setLoading] = useState(null);
  const [step, setStep] = useState(0);
  const [modalNewCredential, setModalNewCredential] = useState(false);
  const [username, setUsername] = useState(null);
  const [listUsers, setListUsers] = useState([]);
  const [backBtnHovered, setBackBtnHovered] = useState(false);
  const changeStep = (number) => {
    if (step !== 0) setStep(number);
  };
  const handleSubmit = (e) => {
    setSelectedMarketplace(e);
    setUsername(e);
  };

  const handleModal = () => {
    setModalNewCredential(true);
  };

  // Función para obtener los username desde la API
  const getAccVtex = async () => {
    try {
      const entId = globalContext.currentEnterpriseId;
      const res = await accVtex("GET",entId);
      console.log("res:", res);
      if (res && res.data) {
        setListUsers(Object.values(res.data)); // Actualiza correctamente el estado
      }
    } catch (error) {
      console.error("Error obteniendo username", error);
    }
  };

  // const getWarehouse = async () => {
  //   try {
  //     const entId = globalContext.currentEnterpriseId;
  //     const res = await getWarehouses(entId);
  //     console.log("res ware:", res);
  //     if (res && res.data) {
  //       setListUsers(Object.values(res.data)); // Actualiza correctamente el estado
  //     }
  //   } catch (error) {
  //     console.error("Error obteniendo username", error);
  //   }
  // };

  // useEffect para monitorear cambios en listUsers
  useEffect(() => {
    console.log(listUsers, "list username actualizada");
  }, [listUsers]); // Solo se ejecutará cuando `listUsers` cambie

  useEffect(() => {
    const hasAccess = verifyAccessRole(Routes, 49);
    if (!hasAccess || GlobalContext.parentEntId) {
      setRedirect(<Redirect to={`/admin/dashboard`} />);
    }
  }, [globalContext.parentEntId]);

  useEffect(() => {
    if (!globalContext.currentEnterpriseId) {
      setStep(0);
    } else {
      setStep(2);
      getAccVtex();
    }
  }, [globalContext.currentEnterpriseId]);

  useEffect(() => {
    if (globalContext.currentEnterpriseId) {
      getAccVtex();
      console.log('hola xd')
    }
  }, [modalNewCredential, loading, selectedMarketplace]);

  useEffect(() => {
    if (!listUsers || !Array.isArray(listUsers)) return;
    if (listUsers.length === 0) {
      if (selectedMarketplace) {
        setSelectedMarketplace(null);
        setUsername(null);
      }
      return;
    }
    if (listUsers.length === 1) {
      const only = listUsers[0].username;
      if (selectedMarketplace !== only) {
        setSelectedMarketplace(only);
        setUsername(only);
      }
      return;
    }
    const stillExists =
      selectedMarketplace &&
      listUsers.some((u) => u.username === selectedMarketplace);
    if (selectedMarketplace && !stillExists) {
      setSelectedMarketplace(null);
      setUsername(null);
    }
  }, [listUsers, selectedMarketplace]);

  const ui = {
    topBar: {
      background: "#fff",
      border: "1px solid #e7eaf3",
      borderRadius: 14,
      padding: "12px 18px",
      boxShadow: "0 8px 22px rgba(31, 41, 55, 0.06)",
      marginTop: 8,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 16,
      flexWrap: "wrap",
    },
    leftCluster: {
      display: "flex",
      alignItems: "center",
      gap: 14,
      flex: "1 1 280px",
      minWidth: 0,
    },
    backBtn: (isHovered) => ({
      width: 42,
      height: 42,
      borderRadius: 12,
      border: "1px solid #e2e8f6",
      background: isHovered ? "#7367f0" : "#f8faff",
      color: isHovered ? "#ffffff" : "#142032",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      flexShrink: 0,
      transition: "background 0.2s ease, color 0.2s ease",
    }),
    segmented: {
      display: "inline-flex",
      background: "#eef3fb",
      border: "1px solid #dce6f5",
      borderRadius: 12,
      padding: 4,
      gap: 4,
      flex: "1 1 auto",
      minWidth: 0,
      maxWidth: "450px",
    },
    segBtn: (active) => ({
      flex: "1 1 0",
      minWidth: 0,
      border: "none",
      borderRadius: 9,
      padding: "10px 14px",
      fontSize: "13px",
      fontWeight: 600,
      cursor: loading || step === 0 ? "not-allowed" : "pointer",
      opacity: loading || step === 0 ? 0.55 : 1,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      background: active
        ? "#7367f0"
        : "transparent",
      color: active ? "#ffffff" : "#334155",
      boxShadow: active ? "0 4px 14px rgba(217, 250, 99, 0.5)" : "none",
      transition: "background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease",
    }),
    accountHint: {
      fontSize: "12px",
      textAlign: "center",
      fontWeight: 600,
      color: "#64748b",
      letterSpacing: "0.04em",
      textTransform: "uppercase",
      marginBottom: 4,
    },
    rightCluster: {
      display: "flex",
      alignItems: "stretch",
      gap: 10,
      flexShrink: 0,
    },
    selectWrap: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: 200,
    },
    select: {
      width: "100%",
      minWidth: 200,
      maxWidth: 280,
      margin: "0 auto",
      height: 44,
      borderRadius: 10,
      border: "1px solid #d8e0f0",
      background: "#f8faff",
      padding: "0 12px",
      fontSize: "14px",
      fontWeight: 500,
      color: "#0f172a",
    },
    accountCapsule: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      alignSelf: "flex-start",
      width: "fit-content",
      minWidth: 120,
      height: 44,
      padding: "0 18px",
      margin: "0 auto",
      borderRadius: 999,
      background: "linear-gradient(135deg, #eef3fb 0%, #e8effc 100%)",
      border: "1px solid #dce6f5",
      fontSize: "14px",
      fontWeight: 600,
      color: "#0f172a",
      maxWidth: 280,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      textAlign: "center",
    },
    emptyAccounts: {
      fontSize: "14px",
      color: "#64748b",
      padding: "10px 0",
    },
    addButtonWrap: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
    },
    addButton: {
      height: 44,
      padding: "0 18px",
      borderRadius: 10,
      background: "#7367f0",
      boxShadow: "0 8px 20px rgba(217, 250, 99, 0.45)",
      fontWeight: 600,
      border: "none",
      color: "#ffffff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      whiteSpace: "nowrap",
    },
  };
  return (
    <>
      <OdooStyle>
        <div className="goBack mt-2" style={ui.topBar}>
          <div style={ui.leftCluster}>
            <Link to="/admin/plugins/my-plugins/my-menu-plugins">
              <button
                type="button"
                className="btn-back"
                style={ui.backBtn(backBtnHovered)}
                aria-label="Volver"
                onMouseEnter={() => setBackBtnHovered(true)}
                onMouseLeave={() => setBackBtnHovered(false)}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
            </Link>

            {selectedMarketplace ? (
              <div style={ui.segmented} role="tablist" aria-label="Sección VTEX">
                <button
                  type="button"
                  role="tab"
                  aria-selected={step === 1}
                  disabled={loading || step === 0}
                  style={ui.segBtn(step === 1)}
                  onClick={() => changeStep(1)}
                >
                  Credenciales
                </button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={step === 2}
                  disabled={loading || step === 0}
                  style={ui.segBtn(step === 2)}
                  onClick={() => changeStep(2)}
                >
                  Operaciones
                </button>
              </div>
            ) : (
              <p style={{ margin: 0, color: "#64748b", fontSize: "14px" }}>
                No se ha seleccionado ninguna cuenta
              </p>
            )}
          </div>

          <div style={ui.rightCluster}>
            {listUsers.length === 0 ? (
              <div style={ui.selectWrap}>
                <span style={ui.accountHint}>Cuenta VTEX</span>
                <span style={ui.emptyAccounts}>Sin cuentas configuradas</span>
              </div>
            ) : listUsers.length === 1 ? (
              <div style={ui.selectWrap}>
                <span style={ui.accountHint}>Cuenta VTEX</span>
                <span style={ui.accountCapsule} title={listUsers[0].username}>
                  {listUsers[0].username}
                </span>
              </div>
            ) : (
              <div style={ui.selectWrap}>
                <span style={ui.accountHint}>Cuenta VTEX</span>
                <PedidosYaStyle.SelectWeb
                  style={ui.select}
                  value={selectedMarketplace || ""}
                  onChange={(e) => handleSubmit(e.target.value)}
                >
                  <option value="">Seleccione una cuenta</option>
                  {listUsers.map((v, index) => (
                    <option value={v.username} key={index}>
                      {v.username}
                    </option>
                  ))}
                </PedidosYaStyle.SelectWeb>
              </div>
            )}
            {(step === 1 || listUsers.length === 0) && (
              <div style={ui.addButtonWrap}>
                <span style={{ ...ui.accountHint, visibility: "hidden" }} aria-hidden>
                  &nbsp;
                </span>
                <Button
                  width="auto"
                  height="auto"
                  className="d-flex justify-content-center align-items-center"
                  minWidth="0px"
                  onClick={handleModal}
                  style={ui.addButton}
                >
                  <span className="d-none d-md-inline">Nueva cuenta</span>
                  <span className="d-inline d-md-none">Nueva</span>
                  <FaPlus />
                </Button>
              </div>
            )}
          </div>
        </div>
        <PedidosYaStyle.Header>
          <PedidosYaStyle.Text size="20pt" fw="600" cl="#142032" style={{ textAlign: "center" }} mt={'16px'} mb={'0'}>
            VTEX Configuración
          </PedidosYaStyle.Text>
        </PedidosYaStyle.Header>
        {selectedMarketplace &&
          step > 0 &&
          selectedMarketplace !== null &&
          !modalNewCredential && (
            <View
              username={selectedMarketplace}
              step={step}
              listUsers={listUsers}
            />
          )}
      </OdooStyle>
      {step > 0 && modalNewCredential && (
        <VtexCredentials
          modalNewCredential={true}
          setModalNewCredential={setModalNewCredential}
          setLoading={setLoading}
        />
      )}
    </>
  );
}
